// 25HOURS GA4 events v2 — 16 个 h25_* prefix custom events
// Loaded with defer; runs after window.gtag('config', G-NZVNW9YK4T) is initialized.
// Coexists with assets/ga4-events.js (does NOT replace it).
//
// Design principles:
//   - GDPR consent gate: skip all tracking if marketing cookie denied
//   - All events prefixed `h25_` to avoid collision with GA4 default / Shopify Google Channel / ga4-events.js
//   - All custom params prefixed `h25_` to avoid collision with gtag built-in params (value/currency/items)
//   - Passive listeners + requestAnimationFrame throttle (no main-thread jank)
//   - Intersection Observer for visibility (native, no polling)
//   - Idempotent: re-execution is a no-op
//
// Last updated: 2026-05-26
(function () {
  'use strict';
  if (typeof window === 'undefined' || window._h25_v2_loaded) return;
  window._h25_v2_loaded = true;

  // ===== 1. GDPR consent gate =====
  function consentOK() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.marketingAllowed === 'function') {
        return window.Shopify.customerPrivacy.marketingAllowed();
      }
    } catch (e) {}
    return typeof window.gtag === 'function';
  }

  function track(name, params) {
    if (!consentOK()) return;
    if (!name || typeof name !== 'string') return;
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
      }
    } catch (e) {}
  }

  // ===== 1b. Pixel relay mirror (h25-pixel container cross-attribution) =====
  // 旁路 dataLayer 监听,白名单 events 同时 POST 到 pixel.25hours.net/h25/{event_name}
  // GA4 端 0 影响 — hook 保留 orig dataLayer.push,先 mirror 再 forward.
  // Whitelist: 5 个 v2 (h25_view_card / h25_image_swipe / h25_expand_accordion /
  //   h25_apply_filter / h25_apply_sort) + 4 个 v1 (scroll_milestone /
  //   engagement_heartbeat / time_to_first_interaction / exit_intent)
  var PIXEL_RELAY_BASE = 'https://pixel.25hours.net/h25';
  var PIXEL_RELAY_WHITELIST = {
    'h25_view_card': 1,
    'h25_image_swipe': 1,
    'h25_expand_accordion': 1,
    'h25_apply_filter': 1,
    'h25_apply_sort': 1,
    'scroll_milestone': 1,
    'engagement_heartbeat': 1,
    'time_to_first_interaction': 1,
    'exit_intent': 1
  };

  function pixelGetCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  function pixelGaClientId() {
    var ga = pixelGetCookie('_ga');
    if (!ga) return '';
    var parts = ga.split('.');
    return parts.length >= 4 ? parts[2] + '.' + parts[3] : '';
  }

  function pixelRelaySend(eventName, params, force) {
    if (!force && !consentOK()) return;
    if (typeof fetch !== 'function') return;
    try {
      var payload = {
        event_id: '',
        event_time_utc: new Date().toISOString(),
        page_url: window.location.href || '',
        referrer: document.referrer || '',
        shopify_y: pixelGetCookie('_y') || pixelGetCookie('_shopify_y'),
        shopify_s: pixelGetCookie('_s') || pixelGetCookie('_shopify_s'),
        client_id: pixelGaClientId(),
        locale: (navigator && navigator.language) || '',
        gtag_params: params || {}
      };
      // 必须 credentials:'omit' — sendBeacon 隐式 include,跟 relay 端 CORS wildcard
      // 'Access-Control-Allow-Origin: *' 冲突 (浏览器铁律:wildcard ACAO 不能搭 credentials)
      fetch(PIXEL_RELAY_BASE + '/' + eventName, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'omit',
        mode: 'cors',
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  // Wrap window.gtag (gtag.js init 后 reassign dataLayer.push,所以 dataLayer hook 不可靠;
  // gtag function 本身一旦定义不会被 reassign,wrap 后续所有 gtag('event', ...) 都过 wrapper)
  function installPixelGtagMirror() {
    if (window._h25_pixel_relay_hooked) return true;
    if (typeof window.gtag !== 'function') return false;
    var origGtag = window.gtag;
    var wrapped = function () {
      try {
        if (arguments[0] === 'event' && typeof arguments[1] === 'string' &&
            PIXEL_RELAY_WHITELIST[arguments[1]]) {
          pixelRelaySend(arguments[1], arguments[2] || {});
        }
      } catch (e) {}
      return origGtag.apply(this, arguments);
    };
    wrapped._h25_wrapped = true;
    window.gtag = wrapped;
    window._h25_pixel_relay_hooked = true;
    return true;
  }

  // Try install immediately + retry (gtag.js 异步加载,init 时刻不确定)
  if (!installPixelGtagMirror()) {
    setTimeout(installPixelGtagMirror, 500);
    setTimeout(installPixelGtagMirror, 1500);
    setTimeout(installPixelGtagMirror, 3500);
  }

  // ===== 2. Helpers =====
  // Note: do NOT use requestIdleCallback — on active pages idle frames may never come
  // and initViewCard() / initElementDwell() observers would never set up.
  // setTimeout(fn, 0) is enough to defer to next tick without blocking main thread.
  function ready(fn) {
    if (document.readyState !== 'loading') {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(fn, 0);
      });
    }
  }

  function throttle(fn, delay) {
    var last = 0, timer = null;
    return function () {
      var now = Date.now();
      var args = arguments;
      var ctx = this;
      var remaining = delay - (now - last);
      if (remaining <= 0) {
        if (timer) { clearTimeout(timer); timer = null; }
        last = now;
        fn.apply(ctx, args);
      } else if (!timer) {
        timer = setTimeout(function () {
          last = Date.now();
          timer = null;
          fn.apply(ctx, args);
        }, remaining);
      }
    };
  }

  function findClosest(el, predicate) {
    var node = el;
    while (node && node !== document.body) {
      if (predicate(node)) return node;
      node = node.parentElement;
    }
    return null;
  }

  // ===== 3. Event delegations + observers =====

  // ---- h25_view_card : Intersection Observer on product cards ----
  function initViewCard() {
    if (!('IntersectionObserver' in window)) return;
    var seen = new Set();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        var el = entry.target;
        var pid = el.dataset.productId || el.dataset.h25CardId || '';
        if (!pid || seen.has(pid)) return;
        seen.add(pid);
        track('h25_view_card', {
          h25_product_id: pid,
          h25_product_handle: el.dataset.productHandle || '',
          h25_card_position: parseInt(el.dataset.productIndex, 10) || 0,
          h25_list_id: el.dataset.listId || '',
          h25_list_name: el.dataset.listName || '',
          h25_page_path: location.pathname
        });
        obs.unobserve(el);
      });
    }, { threshold: [0.5], rootMargin: '0px' });

    document.querySelectorAll('[data-product-card]').forEach(function (el) {
      obs.observe(el);
    });
    // For dynamically loaded cards (infinite scroll): scope MutationObserver to the product
    // grid container, NOT document.body (avoids firing on cart drawer / popover / animations).
    // Falls back to document.body only on collection pages (where the impact is justified).
    var moRoot = document.querySelector('#product-grid, [data-products-container], .collection .grid, main') ||
                 (location.pathname.indexOf('/collections/') !== -1 ? document.body : null);
    if (!moRoot) return;
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('[data-product-card]')) obs.observe(n);
          if (n.querySelectorAll) n.querySelectorAll('[data-product-card]').forEach(function (c) { obs.observe(c); });
        });
      });
    });
    mo.observe(moRoot, { childList: true, subtree: true });
  }

  // ---- h25_apply_filter / h25_apply_sort ----
  function initCollectionInteractions() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      var name = t.name.toLowerCase();
      // Filter inputs: name typically contains "filter."
      if (name.indexOf('filter') !== -1) {
        track('h25_apply_filter', {
          h25_filter_type: name,
          h25_filter_value: (t.value || '').slice(0, 80),
          h25_collection_handle: (location.pathname.match(/\/collections\/([^\/\?]+)/) || [])[1] || '',
          h25_page_path: location.pathname
        });
      } else if (name === 'sort_by' || name === 'sortby' || name.indexOf('sort') !== -1) {
        track('h25_apply_sort', {
          h25_sort_value: (t.value || '').slice(0, 80),
          h25_collection_handle: (location.pathname.match(/\/collections\/([^\/\?]+)/) || [])[1] || '',
          h25_page_path: location.pathname
        });
      }
    }, { passive: true, capture: true });
  }

  // ---- h25_image_zoom / h25_image_swipe / h25_variant_change ----
  function initPdpInteractions() {
    // Image zoom (Shopify Dawn-style modal triggers usually have data-modal-open or product-modal)
    document.addEventListener('click', function (e) {
      var zoomTrigger = findClosest(e.target, function (n) {
        return n.matches && (
          n.matches('[data-image-zoom]') ||
          n.matches('product-modal') ||
          n.matches('.product__media-icon') ||
          n.matches('[aria-label*="zoom" i]') ||
          n.matches('[aria-label*="vergrößern" i]') ||
          n.matches('[aria-label*="enlarge" i]')
        );
      });
      if (zoomTrigger) {
        var pdpEl = findClosest(zoomTrigger, function (n) { return n.matches && n.matches('[data-product-id]'); });
        track('h25_image_zoom', {
          h25_product_id: (pdpEl && pdpEl.dataset.productId) || '',
          h25_page_path: location.pathname
        });
      }
    }, { passive: true, capture: true });

    // Variant change (Shopify variant selector emits 'change' on radio/select inputs)
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (t.name === 'id' || t.name.toLowerCase().indexOf('option') !== -1 || t.closest('variant-selects')) {
        var form = t.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        track('h25_variant_change', {
          h25_variant_id: (form && form.querySelector('input[name="id"]') && form.querySelector('input[name="id"]').value) || t.value || '',
          h25_option_name: t.dataset.optionName || t.name || '',
          h25_option_value: (t.value || '').slice(0, 80),
          h25_page_path: location.pathname
        });
      }
    }, { passive: true, capture: true });

    // Image carousel swipe — listen to scroll on .product__media-list or similar
    var carousels = document.querySelectorAll('.product__media-list, [data-product-media-gallery]');
    carousels.forEach(function (carousel) {
      var lastIdx = -1;
      var emitSwipe = throttle(function () {
        var w = carousel.clientWidth;
        if (w <= 0) return;
        var idx = Math.round(carousel.scrollLeft / w);
        if (idx === lastIdx) return;
        var from = lastIdx;
        lastIdx = idx;
        if (from >= 0) {
          var pdpEl = findClosest(carousel, function (n) { return n.matches && n.matches('[data-product-id]'); });
          track('h25_image_swipe', {
            h25_product_id: (pdpEl && pdpEl.dataset.productId) || '',
            h25_from_index: from,
            h25_to_index: idx,
            h25_page_path: location.pathname
          });
        }
      }, 300);
      carousel.addEventListener('scroll', emitSwipe, { passive: true });
    });
  }

  // ---- h25_expand_accordion / h25_expand_faq ----
  function initAccordions() {
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS') return;
      if (d.classList && d.classList.contains('cart-drawer-container')) return; // skip cart drawer (tracked as cart_viewed)
      if (!d.open) return; // only fire on expand
      var summary = d.querySelector('summary');
      var label = (summary && summary.innerText || '').trim().slice(0, 80);
      // FAQ items typically inside a section with class "faq" or similar
      var isFaq = !!findClosest(d, function (n) {
        return n.matches && (n.matches('[data-faq]') || n.matches('.faq, .faq-section, [class*="faq" i]'));
      });
      if (isFaq) {
        track('h25_expand_faq', {
          h25_question_text: label,
          h25_page_path: location.pathname
        });
      } else {
        track('h25_expand_accordion', {
          h25_section_name: label,
          h25_page_path: location.pathname
        });
      }
    }, { passive: true, capture: true });
  }

  // ---- h25_click_size_guide / h25_click_delivery_info / h25_click_express_checkout ----
  function initCtaClicks() {
    document.addEventListener('click', function (e) {
      var a = findClosest(e.target, function (n) {
        return n.matches && (n.matches('a') || n.matches('button'));
      });
      if (!a) return;
      var txt = (a.innerText || a.getAttribute('aria-label') || '').toLowerCase().trim();
      var href = (a.getAttribute('href') || '').toLowerCase();
      var pdpEl = findClosest(a, function (n) { return n.matches && n.matches('[data-product-id]'); });
      var pid = (pdpEl && pdpEl.dataset.productId) || '';

      if (/size\s*guide|größenführer|größentabelle|größen/i.test(txt) || /size-guide|groessenfuehrer|groessen/.test(href)) {
        track('h25_click_size_guide', { h25_product_id: pid, h25_page_path: location.pathname });
      } else if (/delivery|versand|lieferung|shipping/i.test(txt) || /shipping|versand|delivery/.test(href)) {
        track('h25_click_delivery_info', { h25_product_id: pid, h25_page_path: location.pathname });
      } else if (a.name === 'checkout' || /jetzt zum checkout|express checkout|buy it now|sofort kaufen|jetzt kaufen/i.test(txt)) {
        track('h25_click_express_checkout', { h25_product_id: pid, h25_page_path: location.pathname });
      }
    }, { passive: true, capture: true });
  }

  // ---- h25_change_currency / h25_change_language ----
  function initLocaleSwitch() {
    // Currency: usually a button/select inside .buckscc-currency-wrapper or [data-currency-switcher]
    document.addEventListener('click', function (e) {
      var ccTrigger = findClosest(e.target, function (n) {
        return n.matches && (
          n.matches('[data-currency-switcher] *') ||
          (n.classList && (n.classList.contains('buckscc-currency-item') || n.classList.contains('currency-option')))
        );
      });
      if (ccTrigger) {
        track('h25_change_currency', {
          h25_to_currency: (ccTrigger.dataset.currency || ccTrigger.innerText || '').slice(0, 10),
          h25_page_path: location.pathname
        });
      }
    }, { passive: true, capture: true });

    // Language: Shopify form[action*="/localization"] submit OR data-locale link
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      if (form.matches('form[action*="/localization"]')) {
        var langInput = form.querySelector('input[name="locale_code"], select[name="locale_code"]');
        track('h25_change_language', {
          h25_to_language: (langInput && langInput.value) || '',
          h25_page_path: location.pathname
        });
      }
    }, { passive: true, capture: true });
  }

  // ---- h25_cart_pause / h25_coupon_attempt ----
  function initCartTracking() {
    if (location.pathname.indexOf('/cart') === -1 && !location.pathname.match(/\/checkouts?(\/|$)/)) return;

    // cart_pause: user idle on cart >30s
    var idleTimer = null;
    var pauseFired = false;
    function resetIdle() {
      if (pauseFired) return;
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        pauseFired = true;
        var totalEl = document.querySelector('[data-cart-total], .cart__total, .totals__total-value');
        var items = document.querySelectorAll('.cart-item, [data-cart-item]').length;
        track('h25_cart_pause', {
          h25_cart_total_text: (totalEl && totalEl.innerText || '').slice(0, 30),
          h25_items_count: items,
          h25_page_path: location.pathname
        });
      }, 30000);
    }
    ['mousemove', 'scroll', 'keydown', 'touchstart', 'click'].forEach(function (ev) {
      window.addEventListener(ev, resetIdle, { passive: true });
    });
    resetIdle();

    // coupon_attempt: form submit with discount/coupon input
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      var input = form.querySelector('input[name*="discount" i], input[name*="coupon" i], input[name="reduction_code"]');
      if (input && input.value) {
        track('h25_coupon_attempt', {
          h25_code_entered: input.value.slice(0, 40),
          h25_page_path: location.pathname
        });
      }
    }, { passive: true, capture: true });
  }

  // ---- h25_element_visible : Intersection Observer + dwell ≥5s on opt-in sections ----
  function initElementDwell() {
    if (!('IntersectionObserver' in window)) return;
    var dwell = new Map(); // element → { since: ts, fired: bool, name: str }
    var DWELL_MS = 5000;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        var rec = dwell.get(el);
        if (!rec) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          if (!rec.since) rec.since = Date.now();
        } else {
          rec.since = 0;
        }
      });
    }, { threshold: [0.5] });

    // Targets: any element with [data-h25-track-visible="section_name"]
    // dataset key is camelCase of the attr name with hyphens dropped: data-h25-track-visible → h25TrackVisible
    document.querySelectorAll('[data-h25-track-visible]').forEach(function (el) {
      dwell.set(el, { since: 0, fired: false, name: el.dataset.h25TrackVisible || 'unknown' });
      obs.observe(el);
    });

    var dwellInterval = setInterval(function () {
      dwell.forEach(function (rec, el) {
        if (rec.fired) return;
        if (rec.since && (Date.now() - rec.since) >= DWELL_MS) {
          rec.fired = true;
          var pdpEl = findClosest(el, function (n) { return n.matches && n.matches('[data-product-id]'); });
          track('h25_element_visible', {
            h25_section_name: rec.name,
            h25_product_id: (pdpEl && pdpEl.dataset.productId) || '',
            h25_dwell_sec: Math.round(DWELL_MS / 1000),
            h25_page_path: location.pathname
          });
          obs.unobserve(el);
        }
      });
      // Clear interval once all dwell targets fired (free memory + stop wakeups)
      var allFired = true;
      dwell.forEach(function (rec) { if (!rec.fired) allFired = false; });
      if (allFired) { clearInterval(dwellInterval); }
    }, 1000);
    // Also clear on page unload (SPA-safe)
    window.addEventListener('pagehide', function () { clearInterval(dwellInterval); }, { passive: true, once: true });
  }

  // ---- cart_viewed on cart drawer open (preserve çè´­ç©è½¦ funnel when cart_type=drawer) ----
  // Shopify standard cart_viewed only fires on /cart page nav. With the drawer enabled,
  // re-fire cart_viewed to the h25-pixel container on drawer open. force=true mirrors the
  // Custom Pixel's existing unrestricted cart_viewed (consent-denied parity); drawer-only.
  function initCartDrawerTracking() {
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS') return;
      if (!d.classList || !d.classList.contains('cart-drawer-container')) return;
      if (!d.open) return; // only on open
      pixelRelaySend('cart_viewed', { h25_source: 'drawer', h25_page_path: location.pathname }, true);
    }, { passive: true, capture: true });
  }

  // ===== 4. Boot =====
  ready(function () {
    initViewCard();
    initCollectionInteractions();
    initPdpInteractions();
    initAccordions();
    initCtaClicks();
    initLocaleSwitch();
    initCartTracking();
    initCartDrawerTracking();
    initElementDwell();
  });
})();
